/**
 * API pública: campos editáveis inline (deal, contato, produtos Kanban).
 */
export { InlineEditable } from './InlineEditable';
export type { InlineEditableProps } from './types';
export { useInlineEdit } from './useInlineEdit';
export type { UseInlineEditOptions } from './useInlineEdit';

import { InlineEditable } from './InlineEditable';
import type { ContactLayoutProps, FieldLayoutProps, SelectLayoutProps } from './types';

export const EditableField = (props: Omit<FieldLayoutProps, 'layout'>) => (
    <InlineEditable layout="field" {...props} />
);

export const EditableContactField = (props: Omit<ContactLayoutProps, 'layout'>) => (
    <InlineEditable layout="contact" {...props} />
);

export const EditablePrice = (props: { value: number; onChange: (val: number) => void }) => (
    <InlineEditable layout="cell" cellKind="price" value={props.value} onChange={props.onChange} />
);

export const EditableQuantity = (props: { value: number; onChange: (val: number) => void }) => (
    <InlineEditable layout="cell" cellKind="quantity" value={props.value} onChange={props.onChange} />
);

export const EditableSelect = (props: Omit<SelectLayoutProps, 'layout'>) => (
    <InlineEditable layout="select" {...props} />
);

export default InlineEditable;
